import { memo } from "react";
import { Link } from "react-router-dom";
import NewsletterSignup from "../NewsletterSignup/NewsletterSignup";
import SocialIcons from "../../components/SocialIcons";
import LivroReclamacoes from "../../assets/images/livro-reclamacoes.png";
import "./Footer.css";

const Footer = () => (
  <div className="footer">
    <div className="footer__content-wrapper">
      <NewsletterSignup />

      <div className="footer__contacts-wrapper">
        <p className="footer__title">CRISTIANA SILVA | IMAGEM ESTRATÉGICA</p>
        <p>geral@cristianasilva.pt</p>
        <p>+351 934 920 330</p>
        <div className="footer__social">
          <SocialIcons />
        </div>
      </div>
    </div>

    <div className="footer__complaints-book-wrapper">
      <a
        href="https://www.livroreclamacoes.pt"
        target="_blank"
        referrerPolicy="no-referrer"
        className="footer__complaints-book"
      >
        <img src={LivroReclamacoes} width={120} height={50} />
      </a>
    </div>

    <p className="footer__copyright">
      Cristiana Silva © {new Date().getFullYear()}. Todos os direitos
      reservados.
    </p>
    <div className="footer__legal-links-wrapper">
      <Link className="footer__legal-links" to="/legal/termos-condicoes">
        Termos e Condições
      </Link>
      <span className="footer__legal-links"> | </span>
      <Link className="footer__legal-links" to="/legal/politica-privacidade">
        Política de Privacidade
      </Link>
    </div>
  </div>
);

export default memo(Footer);
